export default function truncateWithEllipsis(value?: string | null, maxChars = 30): string {
  if (!value) {
    return "";
  }

  if (value.length <= maxChars) {
    return value;
  }

  return `${value.slice(0, maxChars)}...`;
}
